import * as React from 'react';

import { Script } from 'gatsby';

import { stripIndent } from 'common-tags';

export function OrttoScript() {
  if (process.env.NODE_ENV !== 'production') {
    return null;
  }

  return (
    <React.Fragment key="ortto-tracking-scripts">
      <Script
        id="ortto-tracking-init"
        strategy="idle"
        dangerouslySetInnerHTML={{
          __html: stripIndent`
            window.ap3c = window.ap3c || {};
            var ap3c = window.ap3c;
            ap3c.cmd = ap3c.cmd || [];
            ap3c.cmd.push(function() {
                ap3c.init('Z-3m57e1l3O8Qfl7c3RpbGVlZHVjYXRpb24', 'https://capture-api.autopilotapp.com/', {
                    cookieDomains: ['.stileeducation.com']
                });
                ap3c.track({v: 0});
            });
            ap3c.activity = function(act) {
              ap3c.act = ap3c.act || [];
              ap3c.act.push(act);
            };
          `,
        }}
      />
      <Script id="ortto-tracking-load" strategy="idle" src="https://cdn2l.ink/app.js" />
    </React.Fragment>
  );
}
